export default __webpack_public_path__ + "f780c210ecac8211626013242c3ecdfc.svg";